import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import Login from '@/views/Login.vue'
import notFound from '@/views/notFound.vue'
import { auth } from "@/firebase";
import store from "@/store"
Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'Not Found',
    component: notFound,
    meta: {
      title: '404'
    }
  },
  {
    path: '/',
    // name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/home.vue'),
        meta: {
          title: 'Home'
        }
      },
      {
        path: '/createSuperAdmin',
        name: 'home',
        component: () => import('@/views/superAdmin/createSuperAdmin.vue'),
        meta: {
          title: 'Create Super Admin Account'
        }
      },
      {
        path: '/clientManagement',
        name: 'clientManagement',
        component: () => import('@/views/superAdmin/management/clientManagement.vue'),
        meta: {
          title: 'Client Management'
        }
      },
      {
        path: '/showManagement',
        name: 'showManagement',
        component: () => import('@/views/admin/management/showManagement.vue'),
        meta: {
          title: 'Show Management'
        }
      },
      {
        path: '/subscribeManagement',
        name: 'subscribeManagement',
        component: () => import('@/views/admin/management/subscribeManagement.vue'),
        meta: {
          title: 'Subscribe Management'
        }
      },
      {
        path: '/myProfile',
        name: 'profile',
        component: () => import('@/views/profile.vue'),
        meta: {
          title: 'My Profile'
        }
      },
      {
        path: '/liveCall',
        name: 'liveCall',
        component: () => import('@/views/liveCall.vue'),
        meta: {
          title: 'Live Call'
        }
      },
      {
        path: '/billing',
        name: 'billing',
        component: () => import('@/views/superAdmin/payment/billing.vue'),
        meta: {
          title: 'Kiosk Billing'
        }
      },
      {
        path: '/cancel',
        name: 'cancel',
        component: () => import('@/views/superAdmin/payment/cancel.vue'),
        meta: {
          title: 'Cancel Payment'
        }
      },
      {
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/superAdmin/payment/payment.vue'),
        meta: {
          title: 'Payment'
        }
      },
      {
        path: '/success',
        name: 'success',
        component: () => import('@/views/superAdmin/payment/success.vue'),
        meta: {
          title: 'Payment Success'
        }
      },
      {
        path: '/showInfo',
        name: 'showInfo',
        component: () => import('@/views/showInfo.vue'),
        meta: {
          title: 'Show Info'
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresGuest: true,
      title: 'Login'
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/admin/Admin.vue'),
    meta: {
      requiresGuest: true,
      title: 'Admin Login'
    }
  },
  {
    path: '/registration/:id',
    name: 'Registration',
    component: () => import('../views/invitedUserRegistration'),
    meta: {
      requiresGuest: true,
      title: 'Invited User Registeration'
    }
  },


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);

  if (requiresAuth && !auth.currentUser) {
    store.dispatch('getAppData').then(response => {
      if (response === 'fetched') {
        next('/login')
      } else {
        next('/admin')
      }
    })
  }
  else {
    next();
  }
})

router.afterEach((to, from) => {
  const DEFAULT_TITLE = 'Dashboard';
  console.log('Route Info: ', from.path)
  if (from.path === '/liveCall') {
    store.dispatch('endCall')
  }
  Vue.nextTick(() => {
    document.title = ` ${to.meta.title} | ${DEFAULT_TITLE} `;
  });
});

export default router
